import { getPreDiscoveryChecklist } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { TASK_STATUS } from '@/helpers/constants';

export async function buildPreEngagementQuestionnaire(taskId) {

    var response = await getPreDiscoveryChecklist(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching task');
        return null;
    }

    const task = response.data;
    
    const route = task.taskStatus === TASK_STATUS.SUCCESSFULLY_COMPLETED.value ? '/tasks/pre-engagement-Questionnaire/' + task.taskId + '/summary' : '/tasks/pre-engagement-Questionnaire/' + task.taskId;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Help us understand your payroll needs',
    subProgressMessage: '',
    status: task.taskStatus,
    route: route, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}


